import { ChartLoseWeight } from "./charts";
import styles from "./styles.module.scss";
import { Button } from "@common/button";

export const GraphStepper = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.chart}>
          <div className={styles.axisx}>
            <span>Weight</span>
          </div>

          <div
            className={styles.eventDate}
            style={{
              left: `${42}%`,
              transform: `translateX(-${10}%)`,
            }}
          >
            <span>Time</span>
          </div>

          {/* <div className={`${styles.withWalky} ${styles.show}`}>With Walky</div> */}

          <ChartLoseWeight isWalky={true} />
        </div>
        <br />
        <br />
        <h2>Your goal is achievable! </h2>
        <br />
        <p>
          Your body and lifestyle may have changed, but small, smart steps can
          still lead you to your goals.
        </p>
        <br />
        <p>
          You can feel strong and confident again —{" "}
          <strong>just like you did at your happiest weight.</strong>
        </p>
      </div>
      <div className={styles.action}>
        <Button variant="walky" onClick={handleNextStep}>
          Continue
        </Button>
      </div>
    </div>
  );
};
